import { useQuery } from '@tanstack/react-query';
import AdminServerActionCreators from 'actions/AdminServerActionCreators';
import { useFireStoreSubscription } from 'hooks/useFireStoreSubscription';
import { useEffect, useState } from 'react';
import { differenceInMinutes } from 'date-fns';
import ShipmentWebAPIUtils, {
  getShipmentModifiedDate,
} from 'utils/ShipmentWebAPIUtils';

const POLLING_INTERVAL = 60000;

function fetchShipmetModifiedDate({ queryKey }) {
  const [, shipmentId] = queryKey;
  return getShipmentModifiedDate(shipmentId);
}

export function useShipmentModifiedDate({ shipmentId }) {
  const {
    data: res,
    loading,
    error,
  } = useQuery({
    queryKey: ['getShipmentModifiedDate', shipmentId],
    queryFn: fetchShipmetModifiedDate,
    refetchInterval: POLLING_INTERVAL,
    refetchIntervalInBackground: true,
    enabled: true,
    refetchOnWindowFocus: true,
  });

  if (res?.data?.item?.modified_at) {
    return { data: res.data?.item?.modified_at, loading, error };
  }

  return { data: undefined, loading, error };
}

export function useShipmentSubscription({ shipmentId }) {
  const [shipment, setShipment] = useState();
  const [shipmentLoaded, setShipmentLoaded] = useState(false);
  const { loading, snapshot, error } = useFireStoreSubscription({
    path: `/shipments/${shipmentId}`,
  });

  const { data: modifiedDate } = useShipmentModifiedDate({ shipmentId });

  async function fetchShipment() {
    ShipmentWebAPIUtils.getShipmentV2(shipmentId);
    setShipmentLoaded(true);
  }

  useEffect(() => {
    if (error || loading || !snapshot) {
      return;
    }

    if (snapshot.exists()) {
      const data = snapshot.data();
      setShipment(data);
      AdminServerActionCreators.receiveShipmentSuccess({ job: data });
    } else if (!shipmentLoaded) {
      fetchShipment();
    }
  }, [loading, snapshot, error, shipmentLoaded]);

  useEffect(() => {
    if (!shipment || !modifiedDate || !shipment.modified_at) {
      return;
    }

    if (differenceInMinutes(modifiedDate, shipment.modified_at) >= 1) {
      ShipmentWebAPIUtils.getShipmentV2(shipmentId);
      setShipmentLoaded(true);
    }
  }, [modifiedDate, shipment]);

  return { shipment, loading, error };
}
